/**
 * 시간 단위 변환 + 공용 staleTime 프리셋.
 *
 * 매직넘버(1000, 60, 5 등)가 staleTime/setTimeout 계산식에 반복 등장하는 걸 막기 위한 단일 출처.
 * 모든 값은 milliseconds 단위로 끝나는 상수만 export — 사용처에서 곱셈 안 해도 되도록.
 */

// ── Atomic units ─────────────────────────────────────────────────
export const MS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;

// ── Derived (ms) ─────────────────────────────────────────────────
export const ONE_SECOND_MS = MS_PER_SECOND;
export const ONE_MINUTE_MS = SECONDS_PER_MINUTE * MS_PER_SECOND;
export const ONE_HOUR_MS = MINUTES_PER_HOUR * ONE_MINUTE_MS;
export const ONE_DAY_MS = HOURS_PER_DAY * ONE_HOUR_MS;

// ── TanStack Query staleTime 프리셋 ──────────────────────────────
// "이 데이터는 최소 N분 동안 fresh 로 본다" — 카테고리 별로 묶어 일관성 확보.
export const STALE_TIME = {
  /** 거의 변하지 않는 메타(약관 버전, 카탈로그 등) */
  LONG: 5 * ONE_MINUTE_MS,
  /** 사용자 프로필/세션 — 새로고침 후엔 다시 가져옴 */
  MEDIUM: 5 * ONE_MINUTE_MS,
  /** 목록/페이지 데이터 — 작성·수정 직후 stale 처리 */
  SHORT: 30 * ONE_SECOND_MS,
} as const;
